import React, { useState, useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./IngredientsPop.module.scss";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import {
  useAddIngredientMutation,
  useUpdateIngredientMutation,
} from "../../../store/services/ingredientService";
import {
  useGetSubCategoryQuery,
  useLazyGetSubCategoryQuery,
} from "../../../store/services/categoryService";
import { useGetSettingsQuery } from "../../../store/services/settingsService";
import toast from "react-hot-toast";
import { CATEGORY_TYPE } from "../../../constants/enum";

const IngredientsPop = ({
  title,
  modalOpen,
  setModalOpen,
  edit,
  settingInfo,
  categoryInfo,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    control,
  } = useForm({
    mode: "onTouched", // Validations mode set to 'onTouched'
    defaultValues: {
      name: edit?.name,
      price: edit?.price,
      description: edit?.description,
      unit: edit?.unit,
      quantity: edit?.quantity,
      nutritionalInfo: {
        calories: edit?.nutritionalInfo?.calories,
        carbohydrates: edit?.nutritionalInfo?.carbohydrates,
        proteins: edit?.nutritionalInfo?.proteins,
        fats: edit?.nutritionalInfo?.fats,
      },
      availability: edit?.availability,
      brands: edit?.brands,
      mealType: edit?.mealType,
      category: edit?.category,
      subCategory: edit?.subCategory,
      state: edit?.state,
    },
  });

  console.log("categoryInfoPop===>", categoryInfo);
  const [bodyData, setBodyData] = useState({
    limit: 50,
    pageNo: 1,
    orderBy: "createdAt",
    order: 1,
    parentCategory: null,
    type: CATEGORY_TYPE.MEAL,
  });
  const unit = settingInfo?.measureUnit?.map((item) => ({
    value: item?.unit,
    label: item?.unit,
  }));
  const quantityOptions = settingInfo?.quantity?.map((item) => ({
    value: item,
    label: item,
  }));

  const mealTypeOptions =
    settingInfo?.mealType?.map((item) => ({
      value: item.type,
      label: item.type,
    })) || [];

  const staticMealTypeOptions = [
    { value: "Breakfast", label: "Breakfast" },
    { value: "Lunch/Dinner", label: "Lunch/Dinner" },
  ];
  const stateOption = [
    { value: "Cooked", label: "Cooked" },
    { value: "Uncooked", label: "Uncooked" },
  ];

  const [selectedIngredients, setSelectedIngredients] = useState(
    edit?.unit ? unit.find((option) => edit.unit.includes(option.value)) : null
  );

  const [selectedMealTypes, setSelectedMealTypes] = useState(
    edit?.mealType
      ? staticMealTypeOptions.filter((option) =>
          edit.mealType.includes(option.value)
        )
      : []
  );

  // const [selectedQuantity, setSelectedQuantity] = useState(
  //   edit?.quantity
  //     ? quantityOptions.find((option) => edit.quantity.includes(option.value))
  //     : null
  // );
  const [addIngredient, { isLoading: isAdding }] = useAddIngredientMutation();
  const [updateIngredient, { isLoading: isUpdating }] =
    useUpdateIngredientMutation();

  const handleMealTypeChange = (selectedOptions) => {
    setSelectedMealTypes(selectedOptions || []);
    const selectedValues = selectedOptions.map((option) => option.value);
    setValue("mealType", selectedValues); // Update react-hook-form state
  };

  // Handler for react-select
  const handleIngredientChange = (selectedOptions) => {
    setSelectedIngredients(selectedOptions || []);
    const mealValues = selectedOptions.value || null;
    setValue("unit", mealValues); // Update react-hook-form state with an array of values
  };

  // Handler for react-select
  // const handleQuantityChange = (selectedOptions) => {
  //   setSelectedQuantity(selectedOptions || []);
  //   const quantity = selectedOptions.value || null;
  //   setValue("quantity", quantity); // Update react-hook-form state with an array of values
  // };

  // Submit handler
  // const onSubmit = async (data) => {
  //   try {
  //     if (edit !== null) {
  //       // Update existing meal
  //       await updateIngredient({
  //         ingredientId: edit._id,
  //         updatedData: data,
  //       });
  //     } else {
  //       await addIngredient(data).unwrap(); // Call deleteIngredient and handle success
  //     }
  //     setModalOpen(false);
  //     return toast.success(
  //       `Ingredient ${edit ? "updated" : "Added"} successfully`
  //     );
  //   } catch (error) {
  //     console.error("Failed to delete the meal:", error); // Handle error
  //   }
  // };

  const onSubmit = async (data) => {
    try {
      // Ensure category name is sent in payload
      const payload = {
        ...data,
        category: selectedIngredient?.label || data.category, // Use category name
      };

      if (edit !== null) {
        await updateIngredient({
          ingredientId: edit._id,
          updatedData: payload, // Send category name in updates
        });
      } else {
        await addIngredient(payload).unwrap(); // Send category name in new addition
      }

      setModalOpen(false);
      toast.success(`Ingredient ${edit ? "updated" : "added"} successfully`);
    } catch (error) {
      console.error("Failed to submit the form:", error);
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };

  const [units, setUnits] = useState([]);
  const [selectedIngredient, setSelectedIngredient] = useState({});

  const handleIngredientChang = (selectedOptions) => {
    setSelectedIngredient(selectedOptions || []);
    const mealValues = selectedOptions.label || null;
    setValue("category", mealValues);
    setValue("subCategory", ""); // Update react-hook-form state with an array of valuess
    setBodyData((prev) => ({
      ...prev,
      parentCategory: selectedOptions?.value || null,
    }));
  };
  const [fetchSubcategory, { data: subCategoryData, error, isLoading }] =
    useLazyGetSubCategoryQuery();

  useEffect(() => {
    const fetchData = async () => {
      if (bodyData.parentCategory) {
        try {
          const response = await fetchSubcategory(bodyData).unwrap();
          console.log(response, "response");
          const subCategoriesOptions = response.data.map((item) => ({
            value: item.name,
            label: item.name,
          }));
          if (edit?.subCategory) {
            const selected = subCategoriesOptions.find(
              (option) => option.value === edit.subCategory
            );
            setSelectedSubCategory(selected);
          }
          setSubCategories(subCategoriesOptions);
        } catch (err) {
          console.error("Error fetching subcategories:", err);
        }
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bodyData.parentCategory]);

  useEffect(() => {
    if (!categoryInfo?.data?.length) {
      return;
    }
    const categories = categoryInfo?.data?.map((item) => ({
      value: item?._id,
      label: item?.name,
    }));

    const data = edit?.category
      ? categories.find((option) => option.label === edit.category)
      : null;
    if (data) {
      setSelectedIngredient(data);
      handleIngredientChang(data);
    }
    setUnits(categories);
  }, [categoryInfo?.data, edit]);

  // State for parent category and subcategorys
  const [parentCategories, setParentCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedParentCategory, setSelectedParentCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  console.log(subCategories, "subCategories");

  // Fetch subcategories based on selected parent category
  // const { data: subCategoryData, isSuccess: subCategorySuccess } = useGetSubCategoryQuery(
  //   selectedParentCategory ? { ...bodyData, category: selectedParentCategory.value } : null,
  //   { skip: !selectedParentCategory }
  // );

  // // Populate parent category options
  // useEffect(() => {
  //   if (!categoryInfo?.data?.length) return;
  //   const categories = categoryInfo.data.map((item) => ({
  //     value: item.name,
  //     label: item.name,
  //   }));
  //   setParentCategories(categories);

  //   // Pre-select parent category if editing
  //   if (edit?.category) {
  //     const selected = categories.find((option) => option.value === edit.category);
  //     setSelectedParentCategory(selected);
  //   }
  // }, [categoryInfo?.data]);

  // Populate subcategory options when API call succeeds

  // Handle Parent Category Change

  const handleParentCategoryChange = (selectedOption) => {
    setSelectedParentCategory(selectedOption);
    setValue("category", selectedOption?.value || "");

    // Reset subcategory when parent category changes
    setSelectedSubCategory(null);
    setValue("subCategory", "");

    // Update API call body
    setBodyData((prev) => ({
      ...prev,
      category: selectedOption?.value || null,
    }));
  };

  // Handle Subcategory Change
  const handleSubCategoryChange = (selectedOption) => {
    setSelectedSubCategory(selectedOption);
    setValue("subCategory", selectedOption?.value || "");
  };

  return (
    <Modal
      show={modalOpen}
      className={`${styles.IngredientsPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
      size="lg"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg="6" md="6" className="my-2">
                  {/* Name Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Name
                    </label>
                    <input
                      placeholder="Enter name"
                      type="text"
                      className="form-control"
                      // {...register("name", { required: "Please enter name" })}
                      {...register("name", {
                        required: "Please enter name",
                        validate: (value) => {
                          if (/^\s/.test(value)) {
                            return "Name cannot start with a space";
                          }
                          // if (/[^a-zA-Z0-9\s]/.test(value)) {
                          //   return "Name cannot include special characters or emojis";
                          // }
                          return true;
                        },
                      })}
                    />
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </div>
                </Col>

                <Col lg="6" md="6" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Meal Type
                    </label>
                    <Select
                      isMulti
                      //options={mealTypeOptions}
                      options={staticMealTypeOptions}
                      value={selectedMealTypes}
                      onChange={handleMealTypeChange}
                      placeholder="Select meal types"
                    />
                  </div>
                </Col>

                <Col lg="4" md="4" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Category
                    </label>
                    <Select
                      name="category"
                      options={units}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={selectedIngredient}
                      onChange={handleIngredientChang}
                      //placeholder="Select category"
                      placeholder="Select category"
                      //isClearable
                    />
                    {errors.parentCategory && (
                      <span className="text-danger">
                        {errors.parentCategory.message}
                      </span>
                    )}
                  </div>
                </Col>

                {/* <Col lg="6" md="6" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Parent Category
                    </label>
                    <Select
                      name="category"
                      options={parentCategories}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={selectedParentCategory}
                      onChange={handleParentCategoryChange}
                      placeholder="Select parent category"
                    />
                    {errors.category && (
                      <span className="text-danger">{errors.category.message}</span>
                    )}
                  </div>
                </Col> */}

                {/* Subcategory Select (Visible only if Parent Category is selected) */}
                {subCategories.length > 0 && (
                  <Col lg="4" md="4" className="my-2">
                    <div className="py-2">
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Sub Category
                      </label>
                      <Select
                        name="subCategory"
                        options={subCategories}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={selectedSubCategory}
                        onChange={handleSubCategoryChange}
                        placeholder="Select sub category"
                      />
                      {errors.subCategory && (
                        <span className="text-danger">
                          {errors.subCategory.message}
                        </span>
                      )}
                    </div>
                  </Col>
                )}

                <Col lg="4" md="4" className="my-2">
                  {/* Price Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Price (AED)
                    </label>
                    <input
                      placeholder="Enter price"
                      type="number"
                      className="form-control"
                      {...register("price", {
                        required: "Please enter price",
                        //min: 0.1,
                      })}
                      step={0.01}
                    />
                    {errors.price && (
                      <span className="text-danger">
                        {errors.price.message}
                      </span>
                    )}
                  </div>
                </Col>

                <Col lg="4" md="4" className="my-2">
                  {/* Quantity (Select) */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Quantity
                    </label>
                    {/* <Select
                      name="quantity"
                      options={quantityOptions}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={selectedQuantity}
                      onChange={handleQuantityChange}
                      placeholder="Select Quantity..."
                    /> */}
                    {/* change quantity from dropdown to input */}
                    <input
                      placeholder="Enter quantity"
                      type="number"
                      className="form-control"
                      {...register("quantity", {
                        required: "Please enter quantity",
                        min: 0,
                      })}
                      step={0.01}
                    />

                    {errors.quantity && (
                      <span className="text-danger">
                        {errors.quantity.message}
                      </span>
                    )}
                  </div>
                </Col>

                <Col lg="4" md="4" className="my-2">
                  {/* Measure Unit (Select) */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Measure Unit
                    </label>
                    <Select
                      name="unit"
                      options={unit}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      value={selectedIngredients}
                      onChange={handleIngredientChange}
                      placeholder="Select measure unit"
                    />
                    {errors.unit && (
                      <span className="text-danger">{errors.unit.message}</span>
                    )}
                  </div>
                </Col>

                <Col lg="4" md="4" className="my-2">
                  {/* Measure Unit (Select) */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      State
                    </label>

                    <Controller
                      name="state"
                      control={control}
                      rules={{ required: "This field is required" }}
                      render={({ field, fieldState: { error } }) => (
                        <>
                          <Select
                            // menuIsOpen
                            {...field}
                            options={stateOption}
                            placeholder="Select state"
                            classNamePrefix="ai-diet"
                            className="font-medium"
                            value={stateOption?.find(
                              (option) => option.value === field.value
                            )}
                            onChange={(selectedOption) => {
                              field.onChange(selectedOption?.value);
                            }}
                          />
                          {error && (
                            <p className="text-danger">
                              {" "}
                              {errors.state.message}
                            </p>
                          )}
                        </>
                      )}
                    />
                  </div>
                </Col>

                <Col lg="12" md="12" className="my-2">
                  {/* Name Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Brand
                    </label>
                    <input
                      type="text"
                      placeholder="Enter brand"
                      className="form-control"
                      // {...register("brands", {
                      //   required: "Please enter brand",
                      // })}
                      {...register("brands", {
                        required: "Please enter brand",
                        validate: (value) => {
                          if (/^\s/.test(value)) {
                            return "Brand cannot start with a space";
                          }
                          if (/[^a-zA-Z0-9\s]/.test(value)) {
                            return "Brand cannot include special characters or emojis";
                          }
                          return true;
                        },
                      })}
                    />
                    {errors.brands && (
                      <span className="text-danger">
                        {errors.brands.message}
                      </span>
                    )}
                  </div>
                </Col>

                <Col lg="12" md="12" className="my-2">
                  {/* Description Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Description
                    </label>
                    <textarea
                      rows={7}
                      placeholder="Enter description"
                      className="form-control h-auto"
                      // {...register("description", {
                      //   required: "Please enter description",
                      // })}
                      {...register("description", {
                        required: "Please enter description",
                        validate: (value) => {
                          if (/^\s/.test(value)) {
                            return "Description cannot start with a space";
                          }
                          // if (/[^a-zA-Z0-9\s]/.test(value)) {
                          //   return "Description cannot include special characters or emojis";
                          // }
                          return true;
                        },
                      })}
                    ></textarea>
                    {errors.description && (
                      <span className="text-danger">
                        {errors.description.message}
                      </span>
                    )}
                  </div>
                </Col>
                <Col lg="12" md="12" className="my-2">
                  {/* Description Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Nutritional Information
                    </label>
                  </div>
                  <Row>
                    <Col lg="3" md="3" className="my-2">
                      {/* Carbohydrates Field */}
                      <div className="py-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Calories
                        </label>
                        <input
                          type="number"
                          placeholder="Enter calories"
                          step="0.01"
                          className="form-control"
                          {...register("nutritionalInfo.calories", {
                            required: "Please enter calories amount",
                            min: 0,
                          })}
                        />
                        {errors.nutritionalInfo?.calories && (
                          <span className="text-danger">
                            {errors.nutritionalInfo.calories.message}
                          </span>
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" className="my-2">
                      {/* Carbohydrates Field */}
                      <div className="py-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Carbohydrates (g)
                        </label>
                        <input
                          type="number"
                          placeholder="Enter carbohydrates"
                          step="0.01"
                          className="form-control"
                          {...register("nutritionalInfo.carbohydrates", {
                            required: "Please enter carbohydrates amount",
                            min: 0,
                          })}
                        />
                        {errors.nutritionalInfo?.carbohydrates && (
                          <span className="text-danger">
                            {errors.nutritionalInfo.carbohydrates.message}
                          </span>
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" className="my-2">
                      {/* Proteins Field */}
                      <div className="py-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Proteins (g)
                        </label>
                        <input
                          type="number"
                          placeholder="Enter protein"
                          step="0.01"
                          className="form-control"
                          {...register("nutritionalInfo.proteins", {
                            required: "Please enter proteins amount",
                            min: 0,
                          })}
                        />
                        {errors.nutritionalInfo?.proteins && (
                          <span className="text-danger">
                            {errors.nutritionalInfo.proteins.message}
                          </span>
                        )}
                      </div>
                    </Col>
                    <Col lg="3" md="3" className="my-2">
                      {/* Fats Field */}
                      <div className="py-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Fats (g)
                        </label>
                        <input
                          type="number"
                          placeholder="Enter fat"
                          step="0.01"
                          className="form-control"
                          {...register("nutritionalInfo.fats", {
                            required: "Please enter fats amount",
                            min: 0,
                          })}
                        />
                        {errors.nutritionalInfo?.fats && (
                          <span className="text-danger">
                            {errors.nutritionalInfo.fats.message}
                          </span>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* <Col lg="6" md="6" className="my-2">
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Status
                    </label>
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="active"
                          {...register("status", {
                            required: "Status is required",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Active
                        </label>
                      </li>
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="inactive"
                          {...register("status", {
                            required: "Status is required",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Inactive
                        </label>
                      </li>
                    </ul>
                    {errors.status && (
                      <span className="text-danger">
                        {errors.status.message}
                      </span>
                    )}
                  </div>
                </Col> */}

                <Col lg="6" md="6" className="my-2">
                  {/* Status Field */}
                  <div className="py-2">
                    <label className="form-label fw-sbold text-muted ps-2 m-0">
                      Availability
                    </label>
                    <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="inStock"
                          {...register("availability", {
                            required: "Availability is required",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          In Stock
                        </label>
                      </li>
                      <li className="d-flex align-items-center">
                        <input
                          type="radio"
                          value="outOfStock"
                          {...register("availability", {
                            required: "One radio button should appear selected",
                          })}
                          className="form-check"
                        />
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          Out Of Stock
                        </label>
                      </li>
                    </ul>
                    {errors.availability && (
                      <span className="text-danger">
                        {errors.availability.message}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>

          {/* <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100"
              >
                {title}
              </Button>
            </div>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default IngredientsPop;
